import React            from "react";
import LeftTopbarItems  from "./LeftTopbarItems";
import RightTopbarItems from "./RightTopbarItems";

export default function TopbarItems() {
    return (
        <div className="navbar-menu-wrapper d-flex align-items-center justify-content-end">
            <LeftTopbarItems />
            <RightTopbarItems />
        </div>
    );
}